import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    myCompany: 'My company',
    tabs: {
      general: 'General information',
      invoicing: 'Invoicing information',
    },
  },
  fr: {
    myCompany: 'Mon entreprise',
    tabs: {
      general: 'Informations générales',
      invoicing: 'Informations de facturation',
    },
  },
} as const);

export default locales;
